import { makeStyles } from '@material-ui/core/styles'

export const modelPickerStyle = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  formControl: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '100%',
    borderRadius: 5
  },
  modelLabel: {
    color: theme.palette.geoColors.toolBar.main,
    marginLeft: theme.spacing(0.2),
    marginTop: theme.spacing(0.2),
    fontSize: '0.9rem',
    userSelect: 'none'
  },
  modelSelect: {
    fontSize: '0.8rem',
    paddingLeft: theme.spacing(0.5)
  }
}))
